<template>
  <alert-resource-list
    :id="id"
    :list-id="id"
    :get-params="mergedGetParams"
    :hidden-columns="hiddenColumns"
    default-time="" />
</template>

<script>
import AlertResourceList from '@Monitor/views/alertresource/components/List'

export default {
  name: 'VmInstanceAlertHistory',
  components: {
    AlertResourceList,
  },
  props: {
    id: String,
    data: {
      type: Object,
      required: true,
    },
    getParams: {
      type: [Object, Function],
      default: () => ({}),
    },
  },
  computed: {
    vmId () {
      return this.data?.id || ''
    },
    mergedGetParams () {
      return () => {
        const base = typeof this.getParams === 'function' ? this.getParams() : this.getParams
        const params = {
          ...(base || {}),
          all_state: true,
          alerting: true,
        }
        if (this.vmId) {
          params.monitor_resource_id = this.vmId
        }
        return params
      }
    },
    hiddenColumns () {
      return ['res_type', 'res_name', 'ip', 'description']
    },
  },
}
</script>
